import React, { useEffect } from 'react';
import { useConfig } from './RestaurantConfigContext';

function hexToRgb(hex) {
    const rgb = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return rgb ? `${parseInt(rgb[1], 16)} ${parseInt(rgb[2], 16)} ${parseInt(rgb[3], 16)}` : null;
}

export default function ThemeProvider({ children }) {
    const { config, loadingConfig } = useConfig();

    useEffect(() => {
        if (!config || loadingConfig) return;

        const { theme } = config.customization;
        const root = document.documentElement;

        if (theme?.primary_color) {
            root.style.setProperty('--primary-color', theme.primary_color);
            root.style.setProperty('--primary-rgb', hexToRgb(theme.primary_color));
        }
        if (theme?.secondary_color) {
            root.style.setProperty('--secondary-color', theme.secondary_color);
            root.style.setProperty('--secondary-rgb', hexToRgb(theme.secondary_color));
        }
        if (theme?.font_style) {
            let fontStr = '';
            // Basic mapping - you can expand this with Google Fonts imports via JS or CSS!
            if (theme.font_style === 'modern') fontStr = '"Inter", "Plus Jakarta Sans", sans-serif';
            if (theme.font_style === 'classic') fontStr = '"Merriweather", "Georgia", serif';
            if (theme.font_style === 'playful') fontStr = '"Sniglet", "Comic Sans MS", cursive';
            
            if (fontStr) {
                root.style.setProperty('--font-family', fontStr);
            }
        }
    }, [config, loadingConfig]);

    return <>{children}</>;
}
